import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-number"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.format()
    this.inputTarget.addEventListener("input", () => {
      this.format()
    })
  }

  format() {
    let phoneNumber = this.inputTarget.value
    phoneNumber = phoneNumber.replace(/\D/g, '') // remove all non-digit characters

    // if nothing is typed in yet, don't apply a format
    if (phoneNumber.length == 0) 
      return;    

    if (phoneNumber.length <= 3) {
      phoneNumber = phoneNumber.replace(/(\d{0,3})/, '($1') // format as (XXX
    } else if (phoneNumber.length <= 6) {
      phoneNumber = phoneNumber.replace(/(\d{0,3})(\d{0,3})/, '($1) $2') // format as (XXX) XXX
    } else if (phoneNumber.length <= 10) {
      phoneNumber = phoneNumber.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3') // format as (XXX) XXX-XXXX
    } else {
      phoneNumber = phoneNumber.replace(/(\d{0,3})(\d{0,3})(\d{0,4})(\d*)/, '($1) $2-$3 ext. $4') // format as (XXX) XXX-XXXX ext. XXXX
    }

    this.inputTarget.value = phoneNumber
  }
}

